import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { logEvent } from '../../../infra/firebase/analytics';
import { AnalyticsEvent, AnalyticsParam } from '../../../domain/analytics';
import styles from './FaqSection.module.css';

interface FaqItem {
  question: string;
  answer: string;
}

function FaqRow({ question, answer, answerId, index }: FaqItem & { answerId: string; index: number }) {
  const [open, setOpen] = useState(false);

  return (
    <li className={styles.item}>
      <button
        className={styles.question}
        onClick={() => { setOpen((o) => !o); logEvent(AnalyticsEvent.landingFaqToggle, { [AnalyticsParam.id]: String(index) }); }}
        aria-expanded={open}
        aria-controls={answerId}
      >
        <span>{question}</span>
        <span className={`${styles.icon} ${open ? styles.iconOpen : ''}`} aria-hidden>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </button>
      <div
        id={answerId}
        className={`${styles.answerWrap} ${open ? styles.answerOpen : ''}`}
        role="region"
        aria-labelledby={answerId}
      >
        <div>
          <p className={styles.answer}>{answer}</p>
        </div>
      </div>
    </li>
  );
}

export default function FaqSection() {
  const { t } = useTranslation('landing');

  const faqs: FaqItem[] = t('faq.items', { returnObjects: true }) as FaqItem[];

  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <header className={styles.header}>
          <h2 className={styles.heading}>{t('faq.heading')}</h2>
        </header>
        <ul className={styles.list} role="list">
          {faqs.map((item, i) => (
            <FaqRow key={item.question} {...item} answerId={`faq-answer-${i}`} index={i} />
          ))}
        </ul>
      </div>
    </section>
  );
}
